import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#367C2B", // Green
    },
    secondary: {
      main: "#FFDE00", // Yellow
    },
    text: {
      primary: "#000000", // Black
    },
  },
  typography: {
    fontFamily: "Open Sans, sans-serif",
  },
  components: {
    // MaterialTable toolbar and selection text styling
    MuiToolbar: {
      styleOverrides: {
        root: {
          "& .MuiTypography-root": {
            color: "#000000", // Black color for selection text
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        body2: {
          color: "#000000", // Black color for body text including selection count
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          "&.Mui-checked": {
            color: "#FFDE00", // Checked color
          },
          "&.MuiCheckbox-indeterminate": {
            color: "#FFDE00", // Indeterminate color (for select all)
          },
        },
      },
    },
  },
  typography: { useNextVariants: true },
});

export const AUDIT_PAGE_TEXT =
  "The below mentioned transport providers confirm that they have transported the mentioned products on behalf of the named mandating unit from the named collection address to the named destination. The provider confirms by this reporting that the information have been made on the basis of the business documents that can be verified in European Community territory.";
